import React from 'react';
import { Select } from '@material-ui/core';

interface Props {
  value: luxon.DateTime,
  onChange: (e: React.ChangeEvent<{
    name?: string | undefined;
    value: unknown;
  }>) => void,
}

/** タクシー・ハイヤー予約画面の日付のセレクトボックスのコンポーネント。 */
export const SelectMonth: React.FC<Props> = (props: Props) => {
  /** 「月」部分（1~12までの数値）の配列。 */
  const months = Array.from({length: 12}, (_, i) => i + 1);

  const setValue = (v: number) => {
    return v.toString().padStart(2, '0');
  }

  /** 初期値。 */
  const defaultValue = props.value.month;

  return (
    <Select native value={defaultValue} onChange={props.onChange}>
      {
        months.map((m) => {
          return <option value={m} key={`months_${m}`}>{setValue(m)}</option>
        })
      }
    </Select>
  );
}

export default SelectMonth;
